/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import config from '@/config'
import Cookies from '@/utils/cookie';
import { setToken } from '@/utils/tools';

export default {
	UPDATE_AUTHENTICATED_USER(state, user) {
		localStorage.setItem('userInfo', JSON.stringify(user));
    localStorage.setItem('userRole', 'user');
    
  },
  SET_TOKEN(state, token) {
    setToken(token.token, token.expire)
    Cookies.set(config.refreshToken, token.refresh_token, { expires: 60, domain: process.env.NODE_ENV === 'production' ? '.haai.net':'localhost'})
  }
}